import type { ModuleDefinition } from "./types";

export const MODULES: ModuleDefinition[] = [
  {
    id: 1,
    name: "Building Your Professional Identity and Ethical Framework",
    stage: "STAGE 1 — FOUNDATION",
    pillars: "Sector-Sensitive Specialization + Value-Based Credentialing",
    templateIds: ["t01", "t02", "t03", "t04"],
  },
  {
    id: 2,
    name: "Designing Your Constitutional Operating Framework",
    stage: "STAGE 1 — FOUNDATION",
    pillars: "Sector-Sensitive Specialization + Value-Based Credentialing",
    templateIds: ["t05", "t06", "t07", "t08"],
  },
  {
    id: 3,
    name: "Designing and Deploying Community Safety Strategies",
    stage: "STAGE 2 — COMPETENCY",
    pillars: "Value-Based Credentialing + Tiered Access",
    templateIds: ["t09", "t10", "t11", "t12"],
  },
  {
    id: 4,
    name: "Building Professional Patrol and Incident Management Tools",
    stage: "STAGE 2 — COMPETENCY",
    pillars: "Value-Based Credentialing + Tiered Access",
    templateIds: ["t13", "t14", "t15", "t16"],
  },
  {
    id: 5,
    name: "Building Officer Safety, Wellness, and Resilience Systems",
    stage: "STAGE 2 — COMPETENCY",
    pillars: "Value-Based Credentialing + Tiered Access",
    templateIds: ["t17", "t18", "t19", "t20"],
  },
  {
    id: 6,
    name: "Designing Your Sentinel Professional Development System",
    stage: "STAGE 2 — COMPETENCY",
    pillars: "Value-Based Credentialing + Tiered Access + Scalable Growth Architecture",
    templateIds: ["t21", "t22", "t23", "t24"],
  },
];

export const MODULE_MAP: Record<number, ModuleDefinition> = Object.fromEntries(
  MODULES.map((m) => [m.id, m]),
);
